module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 7
// module chunks = 0